import ModelService from "./abstract/ModelService";
import VehicleLocking from "../models/VehicleLocking";

export default class VehicleLockingService extends ModelService {
  constructor(id) {
    super('/vehicles/' + id + '/lockings', VehicleLocking);
  }
}